import { useReducer, useState } from 'react';
import { Filters } from './inventoryTypes';
import InventoryHardwareOptionsBar from './InventoryHardwareOptionsBar';
import InventoryHardwareTable from './InventoryHardwareTable';
import { Item } from '../../utils/sharedTypes';
import { Grid } from '@mui/material';
import AnalyzerTypeManagementButton from '../analyzer-types/AnalyzerTypeManagementButton';
import InventoryHardwareFilterBar from './InventoryHardwareFilterBar';

const filtersInitialState: Filters = {
  serial: '',
  hardwareType: null,
  toDateFilter: '',
  fromDateFilter: '',
};

const InventoryHardware = () => {
  const [filters, setFilters] = useReducer(
    (curVals: Filters, newVals: any) => ({ ...curVals, ...newVals }),
    filtersInitialState
  );
  const [selectedAnalyzers, setSelectedAnalyzers] = useState<Item[]>([]);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <>
      <InventoryHardwareFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={filtersInitialState}
      />
      <Grid container spacing={1}>
        <Grid item>
          <InventoryHardwareOptionsBar
            selectedAnalyzers={selectedAnalyzers}
            setSelectedAnalyzers={setSelectedAnalyzers}
            editModalOpenFlag={editModalOpenFlag}
            setEditModalOpenFlag={setEditModalOpenFlag}
          />
        </Grid>

        <Grid item>
          <AnalyzerTypeManagementButton />
        </Grid>
      </Grid>

      <InventoryHardwareTable
        setSelectedAnalyzers={setSelectedAnalyzers}
        setEditModalOpenFlag={setEditModalOpenFlag}
        filters={filters}
      />
    </>
  );
};

export default InventoryHardware;
